import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_tois';

// Example set of params for the query
/*
{
  "position": "30.269083, -97.746544",
  "size": 25,
  "sourceType": "foursquare"
}
 */

const thingsOfInterestQuery = `
    query thingsOfInterest($position: String!, $size: Int) {
        Foursquare: thingsOfInterest(position: $position, size: $size, source: foursquare) {
            uuid
            source
            category
            score
            name
            position {
                lat
                lng
            }
            distance
        }
        Gaia: thingsOfInterest(position: $position, size: $size, source: gaia) {
            uuid
            source
            category
            score
            name
            position {
                lat
                lng
            }
            distance
        }
    }
`;

function thingsOfInterestGraphQl({position, size, locale}) {
    return graphqlQuery(OPERATION_NAME, thingsOfInterestQuery, {position, size}, locale);
}

export default thingsOfInterestGraphQl;
export {OPERATION_NAME, thingsOfInterestGraphQl, thingsOfInterestQuery};
